var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddToCart1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_1705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1392 48.3764H10.8606C9.64785 48.3764 8.60332 47.5213 8.36377 46.3324L3.49707 22.1782H46.5027L41.6359 46.3323C41.3965 47.5212 40.352 48.3764 39.1392 48.3764Z",
    fill: "url(#paint0_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6824 45.6076C35.6035 45.6076 35.5237 45.6018 35.4434 45.5897C34.5709 45.4588 33.9697 44.6453 34.1007 43.7728L36.3222 28.9699C36.4531 28.0974 37.2667 27.4961 38.1391 27.6272C39.0115 27.7582 39.6127 28.5717 39.4817 29.4441L37.2602 44.2471C37.1414 45.0392 36.4599 45.6076 35.6824 45.6076Z",
    fill: "url(#paint1_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3176 45.6076C13.5401 45.6076 12.8587 45.0392 12.7399 44.2471L10.5184 29.4441C10.3874 28.5717 10.9886 27.7583 11.8611 27.6273C12.7333 27.4964 13.547 28.0975 13.678 28.9699L15.8995 43.7729C16.0304 44.6453 15.4292 45.4587 14.5568 45.5897C14.4763 45.6019 14.3964 45.6076 14.3176 45.6076Z",
    fill: "url(#paint2_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6445 45.6074C28.617 45.6074 28.5894 45.6067 28.5616 45.6053C27.6806 45.5602 27.0028 44.8094 27.0478 43.9283L27.8049 29.1254C27.8499 28.2443 28.6022 27.5683 29.4818 27.6116C30.3629 27.6567 31.0406 28.4075 30.9956 29.2886L30.2385 44.0915C30.1949 44.9448 29.4893 45.6074 28.6445 45.6074Z",
    fill: "url(#paint3_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3553 45.6074C20.5104 45.6074 19.8049 44.9449 19.7612 44.0915L19.0041 29.2886C18.959 28.4075 19.6367 27.6567 20.5179 27.6116C21.3989 27.5669 22.1499 28.2442 22.1949 29.1254L22.952 43.9283C22.9971 44.8094 22.3194 45.5602 21.4382 45.6053C21.4105 45.6067 21.3827 45.6074 21.3553 45.6074Z",
    fill: "url(#paint4_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25186 25.9243L26.7038 48.3763H39.1391C40.3519 48.3763 41.3964 47.5212 41.6359 46.3323L46.5027 22.1782H3.49707L4.25186 25.9243Z",
    fill: "url(#paint5_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0063 25.9056H3.99365C1.78809 25.9056 0 24.1176 0 21.912C0 19.7065 1.78809 17.9184 3.99365 17.9184H46.0064C48.212 17.9184 50.0001 19.7065 50.0001 21.912C50 24.1176 48.2119 25.9056 46.0063 25.9056Z",
    fill: "url(#paint6_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3147 25.16C13.1085 25.16 14.5627 23.7058 14.5627 21.9119C14.5627 20.1181 13.1085 18.6639 11.3147 18.6639C9.52085 18.6639 8.06665 20.1181 8.06665 21.9119C8.06665 23.7058 9.52085 25.16 11.3147 25.16Z",
    fill: "url(#paint7_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3148 24.6806C12.8439 24.6806 14.0834 23.441 14.0834 21.9119C14.0834 20.3828 12.8439 19.1433 11.3148 19.1433C9.78571 19.1433 8.54614 20.3828 8.54614 21.9119C8.54614 23.441 9.78571 24.6806 11.3148 24.6806Z",
    fill: "url(#paint8_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9895 17.9184H11.4446L10.8182 19.1885L9.77863 21.2961C9.45686 21.9484 9.62238 22.7133 10.1335 23.1806L12.8585 25.9056H22.9766L14.9895 17.9184Z",
    fill: "url(#paint9_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1335 23.1806L11.6171 24.6642C13.0041 24.5136 14.084 23.3391 14.084 21.9119C14.084 20.3827 12.8442 19.143 11.315 19.143C11.1453 19.143 10.9794 19.1591 10.818 19.1884L9.7785 21.296C9.45691 21.9484 9.62244 22.7132 10.1335 23.1806Z",
    fill: "url(#paint10_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2099 23.6005C10.9726 23.6005 10.7318 23.5475 10.5046 23.4352C9.71326 23.045 9.38816 22.0872 9.7784 21.296L19.0409 2.51523C19.4312 1.72392 20.3889 1.39872 21.1803 1.78915C21.9716 2.17939 22.2967 3.1372 21.9063 3.92841L12.6439 22.7092C12.3657 23.2732 11.7991 23.6005 11.2099 23.6005Z",
    fill: "url(#paint11_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6853 25.16C40.4791 25.16 41.9333 23.7058 41.9333 21.9119C41.9333 20.1181 40.4791 18.6639 38.6853 18.6639C36.8915 18.6639 35.4373 20.1181 35.4373 21.9119C35.4373 23.7058 36.8915 25.16 38.6853 25.16Z",
    fill: "url(#paint12_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5113 25.8727L40.9282 20.2897C40.7555 20.0512 40.5458 19.8415 40.3073 19.6688L38.5569 17.9184H34.9556L36.2834 20.5345L37.356 22.7093C37.4535 22.907 37.587 23.075 37.744 23.2106L40.4392 25.9057H46.0064C46.1776 25.9056 46.3459 25.8936 46.5113 25.8727Z",
    fill: "url(#paint13_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6852 24.6806C40.2142 24.6806 41.4538 23.441 41.4538 21.9119C41.4538 20.3828 40.2142 19.1433 38.6852 19.1433C37.1561 19.1433 35.9165 20.3828 35.9165 21.9119C35.9165 23.441 37.1561 24.6806 38.6852 24.6806Z",
    fill: "url(#paint14_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4539 21.912C41.4539 20.3828 40.2141 19.1431 38.6849 19.1431C37.6574 19.1431 36.7613 19.7032 36.2834 20.5345L37.356 22.7093C37.4536 22.907 37.5871 23.075 37.7441 23.2105L39.171 24.6375C40.4684 24.4076 41.4539 23.2753 41.4539 21.912Z",
    fill: "url(#paint15_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.79 23.6005C39.0274 23.6005 39.2682 23.5475 39.4954 23.4352C40.2867 23.045 40.6118 22.0872 40.2216 21.296L30.9591 2.51523C30.5687 1.72392 29.611 1.39872 28.8197 1.78915C28.0284 2.17939 27.7033 3.1372 28.0936 3.92841L37.3561 22.7092C37.6343 23.2732 38.2009 23.6005 38.79 23.6005Z",
    fill: "url(#paint16_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2755 15.0726C46.9894 15.0726 50 12.062 50 8.34814C50 4.63429 46.9894 1.62363 43.2755 1.62363C39.5617 1.62363 36.551 4.63429 36.551 8.34814C36.551 12.062 39.5617 15.0726 43.2755 15.0726Z",
    fill: "url(#paint17_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6622 10.4578L44.3713 5.04501H42.1799V7.25273H39.9722V9.44413L45.309 14.7597C47.362 14.1092 48.9881 12.5001 49.6622 10.4578Z",
    fill: "url(#paint18_linear_154_1705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.579 7.25283H44.3713V5.04501H42.1799V7.25283H39.9722V9.44413H42.1799V11.6519H44.3713V9.44413H46.579V7.25283Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_154_1705",
    x1: 24.9994,
    y1: 36.1367,
    x2: 24.9994,
    y2: 50.2158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_154_1705",
    x1: 36.2829,
    y1: 35.2897,
    x2: 41.7004,
    y2: 49.3688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_154_1705",
    x1: 12.7012,
    y1: 35.2898,
    x2: 18.1177,
    y2: 49.3689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_154_1705",
    x1: 28.754,
    y1: 35.6572,
    x2: 32.7059,
    y2: 49.7363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_154_1705",
    x1: 20.7105,
    y1: 35.657,
    x2: 24.6624,
    y2: 49.7361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_154_1705",
    x1: 24.9994,
    y1: 44.0807,
    x2: 24.9994,
    y2: 11.0932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE3F45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_154_1705",
    x1: 24.9995,
    y1: 20.4782,
    x2: 24.9995,
    y2: 28.0732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_154_1705",
    x1: 12.0056,
    y1: 22.6037,
    x2: 7.22823,
    y2: 17.8263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_154_1705",
    x1: 10.7252,
    y1: 21.3234,
    x2: 14.7987,
    y2: 25.3959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_154_1705",
    x1: 17.9586,
    y1: 25.9487,
    x2: 2.64031,
    y2: 10.6304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE3F45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_154_1705",
    x1: 15.7241,
    y1: 25.5901,
    x2: 10.1183,
    y2: 19.9843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C3C3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_154_1705",
    x1: 14.8573,
    y1: 12.054,
    x2: 17.2269,
    y2: 13.3991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_154_1705",
    x1: 37.9934,
    y1: 22.6037,
    x2: 42.7707,
    y2: 17.8263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_154_1705",
    x1: 43.2579,
    y1: 25.6518,
    x2: 29.8366,
    y2: 12.2305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE3F45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_154_1705",
    x1: 39.2736,
    y1: 21.3234,
    x2: 35.2002,
    y2: 25.3959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_154_1705",
    x1: 42.6331,
    y1: 25.0265,
    x2: 36.8803,
    y2: 19.2737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C3C3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_154_1705",
    x1: 35.1416,
    y1: 12.054,
    x2: 32.772,
    y2: 13.3991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_154_1705",
    x1: 39.7151,
    y1: 4.78979,
    x2: 54.1286,
    y2: 19.2025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7F3CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61DB99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_154_1705",
    x1: 47.8817,
    y1: 12.9556,
    x2: 40.3504,
    y2: 5.42539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61DB99",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009E74"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_1705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCart1);
export default __webpack_public_path__ + "static/media/add-to-cart 1.cbfc42b89419f92025687316a70210d0.svg";
export { ForwardRef as ReactComponent };